import { render, staticRenderFns } from "./TheBanner.vue?vue&type=template&id=0c7d5bd1"
import script from "./TheBanner.vue?vue&type=script&lang=js"
export * from "./TheBanner.vue?vue&type=script&lang=js"
import style0 from "./TheBanner.vue?vue&type=style&index=0&id=0c7d5bd1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports